import styled from "@emotion/styled"

const ArticleContentTableRow = styled.tr`
 & th {
    padding: 20px;
 }
`

export default ArticleContentTableRow
